<template>
    <v-container>
        <!-- <v-col md="2"></v-col>
        <v-col md="8"> -->
        <v-row>
            <span class="centered text-centered q-title font-weight-light">
                {{ question.question }}
            </span>
        </v-row>
        <br />
        <v-row>
        </v-row>
        <v-row>
            <div v-if="question.optional" class="button-group-wrapper centered text-centered">
                <v-btn-toggle
                    v-model="toggle"
                    mandatory
                >
                  <v-btn :value="1">
                      <span class="font-weight-medium">YES</span>
                  </v-btn>
                  <v-btn :value="0">
                      <span class="font-weight-medium">NO</span>
                  </v-btn>
                </v-btn-toggle>
            </div>
        </v-row>
        <br />
        <span v-if="showTextBox" class="centered text-centered q-subtitle font-weight-light">
        
        </span>
        <br />
        <v-row>
            <div class="centered">
                <v-form ref="form">
                    <v-textarea
                        v-if="showTextBox && !isActivityQuestion && !isUseMoneyQuestion"
                        outlined
                        name="input-7-4"
                        v-model="answer"
                        :rules="questionRules"
                        value=""
                    ></v-textarea>

                    <v-combobox
                        v-if="isActivityQuestion"
                        :items="activityOptions"
                        @change="inputMultiValue"
                        hint="You may type in other activities too"
                        persistent-hint
                        multiple
                        :rules="questionRules"
                        :value="multiValue"
                        outlined
                    >
                        <template v-slot:no-data>
                            <v-list-item>
                                <v-list-item-content>
                                <v-list-item-title>
                                    <!-- Show different message on empty and existing -->
                                    Press  <kbd>enter</kbd>  to add
                                </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </template>
                    </v-combobox>

                    <v-radio-group v-if="isUseMoneyQuestion" v-model="answer" :rules="questionRules" mandatory row>
                        <v-radio class="radio-row-margin radio-column-padding" color="#ea7f1d" :label="option" v-for="option in useMoneyOptions" :key="option" :value="option" :style="answer === option ? 'font-weight: bold;': 'font-weight: normal'"></v-radio>
                    </v-radio-group>
                    
                    <span class="word-counts">{{wordCounts}}</span>
                </v-form>
            </div>
        </v-row>

        <v-row v-if="question.helper_text" justify="center">
            <v-col class="col-8">
                <img src="/help_icon.png" class="bulb-icon" @click="showHelperText = !showHelperText">
                <span :class="showHelperText ? 'visible help-text' : 'hidden help-text'" v-html="question.helper_text"></span>
                
            </v-col>
        </v-row>

        <!-- <v-row :class="{'hide-cells': !showTextBox}">
            <span class="centered body-1 font-weight-medium">
                <fai icon="lightbulb" class="lightbulb-icon"></fai>Education gives you freedom.
            </span>
        </v-row> -->
    </v-container>
</template>
<script>
import axios from 'axios'
import Client from '../client.js';

export default {
    props: {
       sort: [String, Number],
       stage_key: String,
       application_id: [String, Number]
    },
    watch: {
        'sort': async function (sort) {
            let client = Client();
            this.toggle = 1;
            await axios.all([
                client.get(`/stages/${this.stage_key}/questions/${sort}`)
            ])
            .then(ress => {
                this.question = ress[0].data
            });

            await client.get(
                `/applications/${this.application_id}/questions/${this.question.id}`
            )
            .then(response => {
                if (response.data.answer === null) {
                    this.toggle = Number(!this.question.toggle_required);
                } else {
                    this.toggle = this.question.toggle_required;
                }

                this.answer = response.data.answer;
                this.$refs.form.resetValidation();
            })
            .catch(() => {
                this.answer =  null;
                this.$refs.form.resetValidation();
            })
        }
    },
    computed: {
        isUseMoneyQuestion() {
            return this.stage_key.toString() === 'financial_need' && Number(this.sort) === 3;
        },
        multiValue() {
            if(!this.answer) return "";
            return this.answer.split('|');
        },
        isActivityQuestion() {
            return this.stage_key.toString() === 'giving_back' && Number(this.sort) === 2;
        },
        wordCounts() {
            return this.question.min_words ? `min words: ${this.question.min_words}, max words: ${this.question.max_words}` : "";
        },
        questionRules() {
            let component = this;
            return [
                function(v) {
                    if (component.question.optional && component.toggle == component.question.toggle_required) {
                        return v !== null && v !== undefined && v.length > 0;
                    }

                    if (!component.question.optional) {
                        return v !== null && v !== undefined && v.length > 0;
                    }

                    return true;
                },
                v => {
                    if(!this.question.min_words) return true;
                    return !v || v.replace(" ","").length >= this.question.min_words && v.replace(" ","").length <= this.question.max_words;
                }
            ]
        },
        realAnswer() {
            if (this.question.optional && this.toggle == this.question.toggle_required) {
                return this.answer;
            }

            if (!this.question.optional) {
                return this.answer;
            }

            return null;
        },
        showTextBox() {
            if (this.question.optional && this.toggle == this.question.toggle_required) {
                return true;
            }

            if (!this.question.optional) {
                return true;
            }

            return false;
        }
    },
    methods: {
        async submit() {
            let client = Client();
            return await client.post(
                `applications/${this.application_id}/questions/${this.question.id}`,
                { answer: this.realAnswer }
            )
            .then(() => true)
            .catch(() => false);
        },
        inputMultiValue(v) {
            this.answer = v.join('|')
        }
    },
    data: function() {
        return {
            toggle: null,
            question: {},
            answer: null,
            showHelperText: true,
            activityOptions: ['Club sports', 'School sports team', 'Band', 'Choir', 'Drama group', 'AIME', 'Clontarf', 'NASCA', 'Debating', 'Public speaking', 'Chess'],
            useMoneyOptions: ['Textbooks', 'Excursions', 'Uniform items', 'Schools shoes', 'Sneakers', 'Sports equipment', 'Art equipment', 'Subject materials', 'Transport money', 'Stationary', 'Pens & pencils', 'Laptop (which GO helps you purchase for about $450)', 'Internet at home (which GO helps you purchase for about $650 per year)', 'Tutoring', 'Musical instruments', 'Mobile phone', 'Study desk', 'Study chair', 'Calculator', 'Formal or other events at school']
        }
    },
    async beforeMount() {
        let client = Client();
        let ress = await axios.all([
            client.get(`/stages/${this.stage_key}/questions/${this.sort}`)
        ]);

        this.question = ress[0].data;

        console.log('current question', this.question);

        await client.get(
            `/applications/${this.application_id}/questions/${this.question.id}`
        )
        .then(response => {
            if (response.data.answer !== null) {
                this.toggle = this.question.toggle_required;
            } else {
                this.toggle = Number(!this.question.toggle_required);
            }

            console.log('answer response', response.data.answer);
            this.answer = response.data.answer;
            this.$refs.form.resetValidation();
        })
        .catch(() => {
            this.answer =  null;
            this.$refs.form.resetValidation();
        })
    }
}
</script>
<style lang="scss">
.hide-cells {
    display: none !important;
}
.centered {
    margin-left: auto;
    margin-right: auto;
    display: block;
    // width: 70%
}

.button-customization {
    width: 100px;
}

.text-centered {
    text-align: center;
}

.lightbulb-icon {
    color: $go-orange;
    margin-right: 10px;
}

.lightbulb-icon:hover {
    cursor: pointer;
}

.visible {
    display: inline;
}

.hidden {
    display: none;
}

.bulb-icon {
    cursor: pointer;
    margin-right: 10px;
    width:10px;
}

.q-title {
    font-family: $body-font-family;
    font-size: 2.125rem;
    line-height: 2.5rem;
}

.q-subtitle {
    font-family: $secondary-font;
    font-size: 1.5rem;
}

.help-text {
    font-family: $secondary-font;
}
.word-counts {
    font-family: $secondary-font;
    position: relative;
    top: -30px;
}

</style>
